// extracted by mini-css-extract-plugin
module.exports = {"discussionHeader":"default-app_discussionHeader__3ahmb"};